<div class="wrapper">
    <div class="sidebar" data-color="white" data-background-color="darkblue">
        <app-sidebar-cmp></app-sidebar-cmp>
        <div class="sidebar-background"></div>
    </div>
    <div class="main-panel" #content>
        <app-navbar-cmp></app-navbar-cmp>
        <br>
        <router-outlet></router-outlet>
        <div *ngIf="!isMap()">
            <app-footer-cmp></app-footer-cmp>
        </div>
    </div>
    <!-- <app-fixedplugin></app-fixedplugin> -->
</div>